<template>
  <div class="edit standing">
    <div class="standing-bar">
      <el-row>
        <el-button type="primary" size="small" icon="el-hg-icon-edit" :disabled="buttonStart(1)"
                   @click="editStart = false">修改
        </el-button>
        <el-button type="primary" size="small" icon="el-hg-icon-edit" :disabled="buttonStart(2)"
                   @click="riskCheck('0')">保存
        </el-button>
        <el-button type="primary" size="small" icon="el-hg-icon-audit"
                   @click="btnConfirm(riskCheck,'1','确认提交此提单？',0)"
                   :disabled="buttonStart(3)">
          提交
        </el-button>
        <el-button type="primary" size="small" @click="btnConfirm(riskCheck,'2','确认撤回此提单？')"
                   icon="el-hg-icon-sumcancle"
                   :disabled="buttonStart(6)">
          撤回
        </el-button>
        <el-button type="danger" size="small" icon="el-hg-icon-delete"
                   @click="btnConfirm(riskCheck,'3','确认作废此提单？')"
                   :disabled="buttonStart(4)">
          作废
        </el-button>
        <!--<el-button type="primary" size="small" icon="el-icon-back" @click="doCancleAudit" :disabled="buttonStart(3)">退审</el-button>-->
        <!--<el-button type="primary" size="small" icon="el-icon-circle-check" @click="doFinish" :disabled="buttonStart(4)">完成</el-button>-->
        <el-button type="primary" size="small" icon="el-hg-icon-refreash" @click="detail(id)"
                   :disabled="buttonStart(5)">刷新
        </el-button>
        <!--<el-button type="primary" size="small" icon="el-hg-icon-downloadf" :disabled="buttonStart(5)">导出</el-button>-->
        <el-button type="primary" size="small" icon="el-icon-paperclip" @click="enclosureStart = !enclosureStart">附件
        </el-button>
        <el-button type="primary" size="small" icon="el-icon-paperclip"
                   :disabled="buttonStart(7)"
                   @click="pasteOrder">复制提单
        </el-button>
      </el-row>
    </div>
    <div :class="[editStart ? 'standing_conter': 'standing_conter editStart']"
         :style="{height: editModleHeight + 'px'}">
      <div class="edit_from">
        <el-form :model="formInline" class="top-form" ref="topForm" :rules="rules" label-width="90px" size="mini">
          <el-form-item v-for="(itme, key) in fromList" :key="key" :prop="itme.key"
                        :class="[itme.key==='AvailableDays'?'halfW':'']">
            <span slot="label">
              <span v-if="itme.must"><span style="color: red">*</span>
                {{itme.label}}
              </span>
              <span v-else>{{itme.label}}</span>
            </span>
            <el-input v-if="itme.type === 'input'" v-model="formInline[itme.key]" placeholder="请输入内容"
                      :type="itme.contentType==='number'?'number':'text'" :clearable="itme.key!=='AvailableDays'"
                      :disabled="itme.disabled" @change="inputChangeEven(itme.key)"/>
            <el-input v-if="itme.type === 'inputButton'" style="width: 100%" v-model="formInline[itme.key]" clearable
                      :disabled="itme.disabled" placeholder="请输入内容" @change="inputChangeEven(itme.key)">
              <el-button slot="append" v-if="itme.tips" @click="openDialog(itme.dialog)" icon="el-icon-more"
                         :disabled="itme.disabled"></el-button>
            </el-input>
            <el-select v-if="itme.type === 'select'" allow-create clearable :disabled="itme.disabled" filterable
                       v-model="formInline[itme.key]" placeholder="请输入内容">
              <el-option
                v-for="(value, key) in itme.list"
                :key="key"
                :label="value[itme.labelName]"
                :value="value[itme.value]">
                <div v-if="itme.key==='BargainID'">
                  <span>{{value.BargainID}}
                    有效期：{{$utils.getTimeToDay(value.BeginDate)}}-{{$utils.getTimeToDay(value.EndDate)}}</span>
                </div>
              </el-option>
            </el-select>
            <el-autocomplete
              v-if="itme.type === 'inputCustom'"
              :disabled="editStart"
              v-model="formInline[itme.key]"
              :fetch-suggestions="querySearch"
              placeholder="请输入内容"
              @select="inputSelectEven">
              <template slot-scope="{ item }">
                <div class="name">{{ item.BLNO }}</div>
              </template>
            </el-autocomplete>
            <el-date-picker
              @change="datePickerEven(itme.key)"
              :disabled="itme.disabled"
              v-if="itme.type === 'datePicker'"
              v-model="formInline[itme.key]"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期"></el-date-picker>
            <!--:picker-options="pickerOptionsEnd(itme.key)"-->
          </el-form-item>
          <el-form-item label="铅封号" label-width="60px" style="width: 12.5%">
            <el-switch
              :disabled="editStart"
              v-model="formInline.IsNon"
              active-color="#13ce66">
            </el-switch>
          </el-form-item>
          <el-form-item label="车辆取样" label-width="90px" style="width: 12.5%">
            <el-switch
              :disabled="editStart"
              v-model="formInline.ExtractSample"
              active-color="#13ce66">
            </el-switch>
          </el-form-item>
          <el-form-item style="width: 25%" v-if="orderType==='load'">
            <template slot="label">
              <span>附加合同</span>
              <el-tooltip class="item" effect="dark" content="该附加合同指的是需要发清货物的" placement="bottom-end">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <el-select
              allow-create
              clearable filterable
              :disabled="editStart"
              v-model="formInline.Location" placeholder="请输入内容">
              <el-option
                v-for="(value, key) in locationList"
                :key="key"
                :label="value.BargainID"
                :value="value.BargainID">
                 <span>{{value.BargainID}}
                    剩余量：{{value.Number}}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="$route.name === 'adminBillLadingUnload' || $route.name === 'adminAddBillLadingUnload'"
                        label="需要化验" style="width: 12.5%">
            <el-switch :disabled="editStart" v-model="formInline.NeedAssay" active-color="#13ce66"></el-switch>
          </el-form-item>
          <!--   <el-form-item v-else label="提货人" label-width="70px">
               <el-input style="width: 100%" v-model="formInline.TGuestName" :disabled="editStart" placeholder="请输入内容">
                 <el-button slot="append" @click="showTGuestID = true" icon="el-icon-more"
                            :disabled="editStart"></el-button>
               </el-input>
             </el-form-item>-->
        </el-form>
        <el-form class="bottom-form" label-position="right" label-width="90px" size="mini">
          <el-form-item label="特殊要求">
            <el-input
              :disabled="editStart"
              type="textarea"
              :rows="2"
              class="redTxt"
              placeholder="请输入内容"
              v-model="formInline.SpecialRequest"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea"
                      :rows="2" v-model="formInline.Remark" :disabled="editStart" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="edit_table">
        <div class="tableCon" :style="batchNumberListHeight">
          <div class="tableContent-title">罐号信息</div>
          <div class="tableContent" :style="batchNumberListStyle">
            <div class="tableContent-pane">
              <div class="edit_header">
                <el-tooltip class="item" effect="dark" content="新增" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-plus" :disabled="editStart"
                             @click="addNewBatchNumberData"></el-button>
                </el-tooltip>

                <!--<el-button size="small" type="primary" icon="el-icon-edit" ></el-button>-->
                <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-delete" :disabled="editStart"
                             @click="batchNumberDelete"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="刷新列表" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-refresh" :disabled="editStart"
                             @click="batchdetail(id)"></el-button>
                </el-tooltip>
                <!--<el-button size="small" type="primary" icon="el-icon-upload" :disabled="editStart" @click="complete"></el-button>-->
              </div>
              <sp-table
                ref="batchTable"
                :parentTableData.sync="batchFilterData"
                :parentCol.sync="batchNumberCol"
                :dragDrop='true'
                @addNewData="addNewBatchNumberData"
                @selection-change="batchNumberSelectionChange"
                :is-edit="!editStart"
                :summary-data="summaryData"
                show-summary
                :summary-method="getSummaries"
                :tableUID="'batchTable'"
                class="batchTable"
              >
                <el-table-column align="center" type="selection" class="selection"></el-table-column>
                <el-table-column align="center" label="序号" type="index" width="50"/>
                <sp-table-column :align="item.titleAlignment" v-for="(item, index) in batchNumberCol" :key="index"
                                 :prop="batchNumberCol[index].field"
                                 :width="item.width">
                  <template slot="header">
                    <p><b style="color: red" v-if="!item.isNull">*</b>
                      {{item.title}}</p>
                  </template>
                  <template v-slot="{ scope }">
                    <div class="auto-input" v-if="!item.readOnly">
                      <div v-if="carOrderBatchComponent.select.indexOf(item.field) > -1 ">
                        <el-select v-model="scope.row[batchNumberCol[index].field]" placeholder="请选择"
                                   v-show="item.field==='TankID'" clearable
                                   @change="selectOpt(scope)">
                          <el-option
                            v-for="(l,Ti) in TankIDListFilter"
                            :key="Ti"
                            v-show="batchFilterData.findIndex(v=>v.TankID===l.TankID)<0"
                            :label="l.TankID"
                            :value="l.TankID">
                            <span style="margin-right: 2em">罐号：{{l.TankID}}</span>
                            <span v-if="orderType==='load'">可提数：{{ l.CanNumber }}</span>
                          </el-option>
                        </el-select>
                      </div>
                      <div align="center" v-else-if="carOrderBatchComponent.checked.indexOf(item.field) > -1">
                        <el-checkbox v-model="scope.row[batchNumberCol[index].field]"></el-checkbox>
                      </div>
                      <div v-else-if="carOrderBatchComponent.inputButton.indexOf(item.field) > -1">
                        <el-input size="mini" v-model="scope.row[batchNumberCol[index].field]" placeholder="请输入内容">
                          <el-button slot="append"
                                     @click="openDialog(batchNumberCol[index].dialog, scope,batchNumberList)"
                                     icon="el-icon-more"></el-button>
                        </el-input>
                      </div>
                      <div v-else>
                        <el-input size="mini" :type="[3,6,8].indexOf(item.fieldType) >=0?'number':''"
                                  v-model="scope.row[batchNumberCol[index].field]" placeholder="请输入内容"></el-input>
                      </div>
                    </div>
                    <div :class="[item.readOnly ? 'span spanEdit' : 'span']">
                      <div align="center" v-if="carOrderBatchComponent.checked.indexOf(item.field) > -1">
                        <el-checkbox v-model="scope.row[batchNumberCol[index].field]"
                                     :disabled="editStart || item.readOnly" :true-label=1
                                     :false-label=0></el-checkbox>
                      </div>
                      <p v-else :align="item.alignment">{{scope.row[batchNumberCol[index].field]}}</p>
                    </div>
                  </template>
                </sp-table-column>
              </sp-table>
            </div>
          </div>
        </div>
        <div class="tableCon" :style="licenseNumberListHight">
          <div class="tableContent-title">车号信息</div>
          <div class="tableContent" :style="licenseNumberListStyle">
            <div class="tableContent-pane">
              <div class="edit_header">
                <el-tooltip class="item" effect="dark" content="新增" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-plus" :disabled="editStartCAR"
                             @click="addNewLicenseNumberData"></el-button>
                </el-tooltip>
                <!-- <el-tooltip class="item" effect="dark" content="保存" placement="bottom">
                  <el-button size="small" type="primary" icon="el-hg-icon-edit" :disabled="editStartCAR"
                             @click="saveLicenseNumberData"></el-button>
                </el-tooltip> -->
                <!--<el-button size="small" type="primary" icon="el-icon-edit" ></el-button>-->
                <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-delete" :disabled="editStartCAR"
                             @click="licenseNumberDelete"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="刷新列表" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-refresh" :disabled="editStartCAR"
                             @click="LicenseNumberdetail(id)"></el-button>
                </el-tooltip>
                <!--<el-button size="small" type="primary" icon="el-icon-refresh" @click="detail(id)"></el-button>-->
                <!--<el-button size="small" type="primary" icon="el-icon-upload" :disabled="editStart" @click="complete"></el-button>-->
                <el-tooltip class="item" v-if="editStartCAR" effect="dark" content="批量导入车号" placement="bottom">
                  <el-button size="small" type="primary" icon="el-icon-upload" :disabled="editStartCAR"></el-button>
                </el-tooltip>
                <el-upload class="upload-demo" action="" multiple :before-upload="licenseFileEven" v-else>
                  <el-tooltip class="item" effect="dark" content="批量导入车号" placement="bottom">
                    <el-button size="small" type="primary" icon="el-icon-upload"></el-button>
                  </el-tooltip>
                </el-upload>

                <el-input size="mini" type="number" style="width: 130px;margin-right: 10px" v-model="licenseNumberInput"
                          placeholder="请输入数量" :disabled="editStartCAR"></el-input>
                <el-button size="small" :disabled="editStartCAR" type="primary" @click="licenseNumberChange">每车数量分配
                </el-button>
              </div>
              <sp-table
                ref="licenseTable"
                :parentTableData.sync="licenseFilterData"
                :parentCol.sync="licenseNumberClo"
                :dragDrop=true
                @addNewData="addNewLicenseNumberData"
                @selection-change="licenseNumberSelectionChange"
                :is-edit="!editStartCAR"
                :key-dom=1
              >
                <el-table-column align="center" type="selection" class="selection"></el-table-column>
                <el-table-column align="center" label="序号" type="index" width="50"/>
                <sp-table-column :align="item.titleAlignment" v-for="(item, index) in licenseNumberClo" :key="index"
                :prop="licenseNumberClo[index].field"
                                 :width="item.width">
                  <template slot="header">
                    <p><b style="color: red" v-if="!item.isNull">*</b>
                      {{item.title}}</p>
                  </template>
                  <template v-slot="{ scope }">
                    <!--item.readOnly判断数据是否是只读，只读状态下静止编辑-->
                    <div class="auto-input" v-if="!item.readOnly">
                      <div v-if="carOrderListComponent.select.indexOf(item.field) > -1 ">
                        <el-input size="mini" v-model="scope.row[licenseNumberClo[index].field]"
                                  placeholder="请输入内容"></el-input>
                      </div>
                      <div align="center" v-else-if="carOrderListComponent.checked.indexOf(item.field) > -1">
                        <el-checkbox v-model="scope.row[licenseNumberClo[index].field]"></el-checkbox>
                      </div>
                      <div v-else-if="carOrderListComponent.datePicker.indexOf(item.field) > -1">
                        <el-date-picker
                          v-model="scope.row[licenseNumberClo[index].field]"
                          type="date"
                          value-format="yyyy-MM-dd"
                          size="mini"
                          placeholder="选择日期时间">
                        </el-date-picker>
                      </div>
                      <div v-else>
                        <el-input size="mini" :type="[3,6,8].indexOf(item.fieldType) >=0?'number':''"
                                  v-model="scope.row[licenseNumberClo[index].field]" placeholder="请输入内容"></el-input>
                      </div>
                    </div>
                    <div :class="[item.readOnly ? 'span spanEdit' : 'span']">
                      <div align="center" v-if="carOrderListComponent.checked.indexOf(item.field) > -1">
                        <el-checkbox v-model="scope.row[licenseNumberClo[index].field]"
                                     :disabled="editStart || item.readOnly" :true-label=1
                                     :false-label=0></el-checkbox>
                      </div>
                      <p v-else :align="item.alignment">{{scope.row[licenseNumberClo[index].field]}}</p>
                    </div>
                  </template>
                </sp-table-column>
              </sp-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <grid-dialog :show="showGoodsID"
                 title="产品选择"
                 :page-type="type"
                 :default-params="refGoodsDefaultParams"
                 :grid-config="refGoodsByConditionsList"
                 :default-values.sync="goodsDefaultValue"
                 :default-keys="goodsDefaultKeys"
                 :ref-value.sync="formInline"
                 :dataUpdate="dataUpdate"
                 @close="showGoodsID = !showGoodsID"></grid-dialog>
    <grid-dialog :show="showTankID"
                 title="罐号选择"
                 :page-type="type"
                 :default-params="TankIDDefaultParams"
                 :grid-config="TankIDByConditions"
                 :default-values.sync="TankIDDefaultValue"
                 :dataUpdate="dataUpdate"
                 :default-keys="TankIDDefaultKey"
                 :ref-list.sync="batchNumberList"
                 :ref-list-index.sync="currentTank"
                 @close="showTankID = !showTankID"></grid-dialog>
    <grid-dialog :show="showTGuestID"
                 title="提货人选择"
                 :page-type="type"
                 :dataUpdate="dataUpdate"
                 :default-params="TGuestIDDefaultParams"
                 :grid-config="TGuestIDByConditions"
                 :default-values.sync="TGuestIDDefaultValue"
                 :default-keys="TGuestIDDefaultKeys"
                 :ref-value.sync="formInline"
                 @close="showTGuestID = !showTGuestID"></grid-dialog>
    <Dialog title="附件" :width="600" :height="400" :visible="enclosureStart" @close="enclosureStart = !enclosureStart">
      <div class="grid-contain dialog edit">
        <div style="margin-bottom: 20px" v-if="buttonStart(10)">
          <el-button type="primary" size="small" icon="el-icon-upload2" @click="uploadFileDesc = !uploadFileDesc">上传文件
          </el-button>
        </div>
        <div class="grid-table">
          <sp-table
            ref="batchTable"
            :parentTableData.sync="annexDetailList"
            :parentCol.sync="enclosureAction">
            <el-table-column align="center" type="selection" class="selection"></el-table-column>
            <el-table-column align="center" label="序号" type="index" width="50"/>
            <sp-table-column v-for="(item, index) in enclosureAction" :key="index" :width="item.width">
              <template slot="header">
                <p>{{item.title}}</p>
              </template>
              <template v-slot="{ scope }">
                <div class="span" v-if="item.field !== 'edit'">
                  <p>{{scope.row[enclosureAction[index].field]}}</p>
                </div>
                <div class="span" v-else>
                  <el-button type="primary" size="small" @click="fileDownload(scope.row)">下载
                  </el-button>
                  <el-button type="danger" v-if="buttonStart(10)" size="small" @click="fileDelete(scope.row)">删除
                  </el-button>
                </div>
              </template>
            </sp-table-column>
          </sp-table>
        </div>
      </div>
    </Dialog>
    <Dialog title="上传文件说明" :width="400" :height="100" :visible="uploadFileDesc"
            @close="uploadFileDesc = !uploadFileDesc">
      <div class="grid-contain dialog edit">
        <el-form label-width="80px">
          <el-form-item label="描述" class="required">
            <el-input v-model="desc" placeholder="请输入说明后再选择文件"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" style="width:100%;text-align: right;display: flex;justify-content:center;">
          <el-upload
            class="upload-demo"
            action=""
            name="file"
            :show-file-list="false"
            :http-request="beforeAvatarUpload">
            <el-button size="small" :disabled="!desc" icon="el-hg-icon-save" type="primary">选择文件</el-button>
          </el-upload>
          <el-button size="small" icon="el-hg-icon-close" type="danger" @click="uploadFileDesc = !uploadFileDesc"
                     style="margin-left: 20px">关 闭
          </el-button>
        </div>
      </div>
    </Dialog>
    <Dialog :title="'请输入手机号'+ Codephone+'收到的验证码'" :width="400"
            :height="100" :visible="msgCodeShow"
            @close="msgCodeShow = !msgCodeShow">
      <div class="grid-contain dialog edit">
        <el-form label-width="80px" style="margin-top: 10%">
          <el-form-item label="验证码" class="required">
            <el-input size="small" v-model="msgCode" placeholder="请输入六位验证码"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" style="width:100%;text-align: right;display: flex;justify-content:center;">
          <el-button size="small" icon="el-hg-icon-save" type="primary" @click="checkMsgCode"
                     style="margin-left: 20px">确定
          </el-button>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from 'vuex';
  import {spTable, spTableColumn} from '@/components/sptable';
  import dayjs from 'dayjs';
  import gridDialog from '@/components/gridDialog';
  import Dialog from '@/components/dialog';
  import storageM from '@/storage';
  import {Loading} from 'element-ui';

  const storage = storageM['sessionStorage'];

  export default {
    name: 'edit',
    components: {
      spTable,
      spTableColumn,
      gridDialog,
      Dialog,
    },
    data() {
      return {
        summaryData: '',
        Codephone: '',
        msgCode: '',
        msgCodeShow: false,
        dataUpdate: false,
        editStart: true, // 判断页面是否是编辑状态，所有可输入框是根据该字段判定
        editStartCAR: true, // 车辆信息修改判断
        id: '', // 订单唯一id
        type: '', // 页面入口进入不同，导致页面中的状态不同，根据状态判定页面页面是否可以编辑，是否添加，预览状态
        activeName: '罐号信息',
        showGoodDic: false,
        showGuestId: false,
        showBargainID: false,
        showGoodsID: false,
        showgetTGuest: false,
        showLocation: false,
        showTankID: false,
        showTGuestID: false,
        showAttachBargain: false,
        enclosureStart: false,
        uploadFileStart: false,
        uploadFileDesc: false,
        goodDIcDefaultParams: {
          type: 'GUESTBUSINESS',
          url: this.OrderType ? 'getInCarRefGoods' : 'getOutCarRefGoods',
          params: {
            goodsId: '',
          },
        },
        batchNumberOriginData: {},
        licenseNumberOriginData: {},
        batchNumberList: [],
        licenseNumberList: [],
        bargainList: [],
        getRefGoodsList: [],
        locationList: [],
        guestIDList: [],
        getBlnoList: [],
        BargainList: [],
        rules: {
          BargainID: [{
            required: true,
            message: '请选择合同号',
            trigger: ['blur', 'change']
          }],
          GoodsID: [{
            required: true,
            message: '请选择产品',
            trigger: ['blur', 'change']
          }],
          BLNO: [{
            required: true,
            message: '请输入提单号',
            trigger: ['blur', 'change']
          }], BLNumber: [{
            required: true,
            message: '请输入提单数',
            trigger: 'blur'
          }], BLBeginDate: [{
            required: true,
            message: '请选择开始时间',
            trigger: 'blur'
          }], BLEndDate: [{
            required: true,
            message: '请选择结束时间',
            trigger: 'blur'
          }],
        },
        formInline: {
          IsNon: false,
          ExtractSample: false,
          Remark: '',
          SpecialRequest: '',
          BLNO: '',
          OperatorID: '',
          CreateDate: '',
          Name: '',
          GuestID: '',
          CEGoodsName: '', // 产品名称
          GoodsID: '', // 产品id
          BLNumber: '', // 列单数
          BargainID: '', // 合同编号
          BillID: '', // 流水号
          Location: '',
          TGuestID: '',
          TGuestName: ''
        },
        licenseNumberUserSelectId: [], // 批号选择id集合
        batchNumberUserSelectId: [], // 车号选择id集合
        detailInfo: {State: 0},
        getServiceIdList: [],
        MainOrder: '',
        guestIdDefaultValue: {
          Name: 'Name',
          GuestID: 'GuestID',
        },
        guestIdDefaultKeys: 'GuestId',
        goodsDefaultValue: {
          Name: 'CEGoodsName',
          GoodsID: 'GoodsID',
        },
        goodsDefaultKeys: 'GoodsID',
        BargainIDDefaultValue: {
          BargainID: 'BargainID',
        },
        locationDefaultValue: {
          BargainID: 'Location',
        },
        TGuestIDDefaultValue: {
          GuestID: 'GuestID',
        },
        TGuestIDDefaultKey: 'GuestID',
        TankIDDefaultValue: {
          AccountID: 'AccountID',
          BargainID: 'BargainID',
          BatchNo: 'BatchID',
          CanNumber: 'CanNumber',
          // Number: 'CanNumber',
          GoodsID: 'GoodsID',
          GoodsName: 'GoodsName',
          GuestID: 'GuestID',
          GuestName: 'GuestName',
          IsInTrade: 'IsInTrade',
          IsOutTrade: 'IsOutTrade',
          IsTax: 'IsTax',
          LockNumber: 'LockNumber',
          MadeNumber: 'MadeNumber',
          OrderNumber: 'OrderNumber',
          PassNo: 'PassNo',
          Remark: 'Remark',
          TankID: 'TankID',
        },
        TankIDDefaultKey: 'GuestID',
        TGuestIDDefaultValue: {
          GuestName: 'TGuestName',
          GuestID: 'TGuestID',
        },
        TGuestIDDefaultKeys: 'TGuestID',
        currentTank: 0,
        bargainDefaultValue: {
          BargainID: 'BargainID',
        },
        bargainDefaultKeys: 'BargainID',
        AttachBargainDefaultValue: {
          BatchNo: 'Location'
        },
        AttachBargainDefaultKey: 'BatchNo',
        carOrderBatchComponent: {
          select: ['TankID',],
          checked: ['IsInTrade', 'IsOutTrade', 'IsTax',],
          inputButton: ['BatchID',],
        },
        carOrderListComponent: {
          select: [],
          checked: ['IsDate'],
          datePicker: ['CarBeginDate', 'CarEndDate']
        },
        OrderType: false, // 判断是否是装车还是卸车
        batchNumberCol: [],
        licenseNumberClo: [],
        Step: '',
        fileUpload: '',
        desc: '',
        annexDetailList: [],
        editModleHeight: 0,
        batchNumberListStyle: {},
        batchNumberListHeight: {
          minHeight: '200px',
          marginBottom: '35px'
        },
        licenseNumberListStyle: {},
        licenseNumberListHeight: {
          minHeight: '200px',
          marginBottom: '55px'
        },
        refGoodsList: [],
        TankIDList: [],
        licenseNumberListHight: '',
        orderType: '',
        licenseNumberInput: 0,
        currF: '',
        currFpar: '',
      };
    },
    computed: {
      ...mapGetters({
        userInfor: 'user/userInfor',
        goodDicList: 'dictionary/goodDicList',
        guestIDByConditionsList: 'dictionary/guestIDByConditionsList',
        bargainIDByConditionsList: 'dictionary/bargainIDByConditionsList',
        refGoodsByConditionsList: 'dictionary/refGoodsByConditionsList',
        carOrderBatch: 'dictionary/adminCarOrderBatch',
        carOrderList: 'dictionary/adminCarOrderListAction',
        TGuestIDByConditions: 'dictionary/TGuestIDByConditions',
        TankIDByConditions: 'dictionary/TankIDByConditions',
        visitedViews: 'tags/visitedViews',
      }),
      TankIDListFilter() {
        let arr = [];
        this.TankIDList.forEach(v => {
          this.batchNumberList.forEach(itme => {
            if (v.TankID && (v.TankID !== itme.TankID || itme.updateFlg === 'delete') && arr.findIndex(a => v.TankID === a.TankID) < 0) {
              arr.push(v);
            }
          })
        });
        return arr;
      },
      fromList() {
        let list = [
          {
            label: '合同号',
            key: 'BargainID',
            type: 'select',
            showDialog: true,
            tips: '...',
            list: this.BargainList,
            labelName: 'BargainID',
            value: 'BargainID',
            disabled: this.editStart,
            must: true
          },
          {
            label: '产品',
            key: 'GoodsID',
            type: 'select',
            showDialog: true,
            tips: '...',
            list: this.refGoodsList,
            labelName: 'GoodsName',
            value: 'GoodsID',
            disabled: this.editStart,
            must: true
          },
          {
            label: '提单号',
            key: 'BLNO',
            type: 'input',
            list: this.getBlnoList,
            labelName: 'BLNO',
            value: 'BLNO',
            disabled: this.editStart,
            must: true
          },
          {
            label: '提单数',
            key: 'BLNumber',
            type: 'input',
            disabled: this.editStart,
            must: true,
            contentType: 'number',
          },
          {
            label: '开始时间',
            key: 'BLBeginDate',
            type: 'datePicker',
            default: `${this.$utils.getTimeByDay(new Date())} 00:00:01`,
            disabled: this.editStart,
            must: true
          },
          {
            label: '结束时间',
            key: 'BLEndDate',
            type: 'datePicker',
            default: `${this.$utils.getTimeByDay(new Date())} 23:59:59`,
            disabled: this.editStart,
            must: true
          },
          {
            label: '有效天数',
            key: 'AvailableDays',
            type: 'input',
            default: 4,
            disabled: this.editStart,
            contentType: 'number',
          },
        ];
        /* if ((list.length === 12 && this.$route.name === 'billLadingUnload') || (this.$route.name === 'addBillLadingUnload' && list.length === 10)) {
           list.splice(10, 2);
         }
         else if (list.length === 7 && (this.$route.name === 'adminBillLadingUnload' || this.$route.name === 'adminAddBillLadingUnload')) {
           list.splice(3, 1);
         }*/
        return list;
      },
      BargainListParams() {
        let params = {
          orderType: this.orderTypeC(3, 2)
        };
        let info = {
          type: 'GUESTBUSINESS',
          url: 'getBargainByOrderType',
          params,
        };
        return info;
      },
      locationListParams() {
        let params = {
          bargainId: this.formInline.BargainID ? this.formInline.BargainID : '',
          goodsId: this.formInline.GoodsID ? this.formInline.GoodsID : this.formInline.CEGoodsName,
        };
        let info = {
          type: 'GUESTBUSINESS',
          url: 'getLocation',
          params,
        };
        return info;
      },
      refGoodsDefaultParams() {
        let params = {
          bargainId: this.formInline.BargainID ? this.formInline.BargainID : '',
          goodsId: this.formInline.GoodsID ? this.formInline.GoodsID : this.formInline.CEGoodsName,
        };
        let info = {
          type: 'GUESTBUSINESS',
          url: this.orderTypeC('getOutCarRefGoods', 'getInCarRefGoods'),
          params,
        };
        return info;
      },
      TankIDDefaultParams() {
        let params = {
          bargainId: this.formInline.BargainID,
          goodsId: this.formInline.GoodsID ? this.formInline.GoodsID : this.formInline.CEGoodsName,
          billId: this.formInline.BillID,
          location: this.formInline.Location,
        };
        let info = {
          type: 'GUESTBUSINESS',
          url: this.orderTypeC('getOutCarTank', 'getInCarTank'),
          params,
        };
        if (params.billId === '') {
          info = false;
        }
        return info;

      },
      TGuestIDDefaultParams() {
        let params = {
          goodsId: this.formInline.GoodsID ? this.formInline.GoodsID : this.formInline.CEGoodsName,
          tGuestId: this.formInline.TGuestName ? this.formInline.TGuestName : ''
        };
        let info = {
          type: 'GUESTBUSINESS',
          url: 'getRefTGuest',
          params,
        };
        return info;
      },
      AttachBargainDefaultParams() {
        let params = {
          goodsId: this.formInline.GoodsID ? this.formInline.GoodsID : this.formInline.CEGoodsName,
          guestId: this.formInline.CEGoodsName ? this.formInline.GuestID : '',
          bargainId: this.formInline.BargainID,
        };
        let info = {
          type: 'GUESTBUSINESS',
          url: 'getAttachBargain',
          params,
        };
        return info;
      },
      enclosureAction() {
        return [
          {width: 160, title: '附件描述', field: 'explain'},
          {width: 160, title: '附件名称', field: 'annexname'},
          {width: 160, title: '添加人', field: 'operatorid'},
          {width: 160, title: '添加时间', field: 'adddate'},
          {width: 160, title: '编辑', field: 'edit'},
        ]
      },
      batchFilterData: {
        get() {
          return this.batchNumberList.filter(v => v.updateFlg !== 'delete')
        },
        set(v) {
          v ? this.batchNumberList = v : '';
        }
      },
      licenseFilterData: {
        get() {
          return this.licenseNumberList.filter(v => v.updateFlg !== 'delete')
        },
        set(v) {
          v ? this.licenseNumberList = v : '';
        }
      },
    },
    activated() {
      if (this.id !== this.$route.query.id) {
        this.init();
      } else {
        let start1 = storage.$get({key: 'adminServiceTableDetail',});
        if (start1) {
          storage.$remove({
            key: 'adminServiceTableDetail',
          });
          this.init();
        }
      }
    },
    mounted() {
      this.editModleHeight = window.document.body.clientHeight - 139;
      this.$route.name === 'adminAddBillLadingLading' || this.$route.name === 'adminBillLadingLading' ? this.orderType = 'load' : '';
      this.$route.name === 'adminAddBillLadingUnload' || this.$route.name === 'adminBillLadingUnload' ? this.orderType = 'unload' : '';
      this._getDataList(this.BargainListParams, this.BargainIDDefaultValue, 'BargainList');
      this._getDataList(this.locationListParams, this.locationDefaultValue, 'locationList');
      this._getDataList(this.refGoodsDefaultParams, this.goodsDefaultValue, 'refGoodsList');
      this.TankIDDefaultParams ? this._getDataList(this.TankIDDefaultParams, this.TankIDDefaultValue, 'TankIDList') : '';
    },
    methods: {
      licenseNumberChange() {
        this.licenseNumberList.forEach((itme, i) => {
          if (itme.updateFlg !== 'delete') {
            this.$set(this.licenseNumberList[i], 'Number', this.licenseNumberInput);
          }
        });
      },
      btnConfirm(F, pf, str, par,) {
        this.$confirm(str, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (typeof F === "function") F(pf, par);
        });
      },
      getSummaries(param) {
        const countList = ['CanNumber', "Number"];
        const countObj = {
          CanNumber: {
            unit: ' ',
          }, Number: {
            unit: ' ',
          },
        };
        const {columns, data} = param;
        let sums = [];
        columns.forEach((column, index) => {
          if (index === 1) {
            sums[index] = '合计';
            return;
          }
          if (countObj[column.property]) {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                }
                return prev;
              }, 0);
              sums[index] = sums[index].toFixed(3);
              sums[index] += countObj[column.property].unit;
            }
            else {
              sums[index] = '';
            }
          }
        });
        this.summaryData = [countList, sums];
        return sums;
      },
      selectOpt(row) {
        let orgIndex = this.batchNumberList.findIndex(x => {
          return x.uid == row.row.uid;
        });
        let refValue = this.TankIDList.filter(item => item.TankID === row.row.TankID);
        delete refValue[0].IsInTrade;
        Object.assign(this.batchNumberList[orgIndex], refValue[0], {updateFlg: 'add'});
      },
      async _getDataList(defaultParamsValue, defaultValues, list) {
        this.loading = true;
        let {url, type, params} = defaultParamsValue;
        const {bean} = await this.$services.post({
          url,
          type,
          params: Object.assign({}, params, {accountId: this.userInfor && this.userInfor.accountId})
        });
        //新增时弹出选择的数据只有一条时，将数据直接赋值到页面
        if (bean.length === 1 && this.type === 'add' && url !== 'getLocation') {
          let refValue = {};
          let re = true;
          Object.entries(defaultValues).forEach(v => {
            // !(v[1] === 'CanNumber' && v[0] === 'Number') && bean[0][v[0]] ? refValue[v[1]] = bean[0][v[0]] : '';
            bean[0][v[0]] ? refValue[v[1]] = bean[0][v[0]] : '';
            //（除罐号信息外）相等不再赋值，避免监听造成死循环
            this.formInline && refValue && this.formInline[v[1]] === refValue[v[1]] && this.formInline[v[1]] !== undefined ? re = false : '';
          });
          if (re) {
            this.formInline ? this.formInline = Object.assign({}, this.formInline, refValue) : '';
          } else if ((url === 'getOutCarTank' || url === 'getInCarTank') && !re) {
            this.batchNumberList ? this.$set(this.batchNumberList, 0, Object.assign({}, refValue, {updateFlg: 'add', IsInTrade: true})) : '';
          }
        }
        else if ((url === 'getOutCarTank' || url === 'getInCarTank') && this.type === 'add') {
          //附加合同号不为空情况下获取的罐号全部赋值，否则清空全部罐号条数
          this.formInline.Location ? this.batchNumberList = bean.map(v => Object.assign({}, v, {updateFlg: 'add'})) : this.batchNumberList = [];
        }
        this.loading = false;
        this[list] = bean;
      },
      pasteOrder() {
        let choose = false;
        this.$confirm('是否清空车号？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          choose = true;
          this.licenseNumberList = []
        }).catch(() => {
        });

        this.visitedViews.forEach(v => {
          if (v.path === this.$route.path) {
            v.title = '新增' + v.title.replace(/详情/, '');
          }
        });
        this.$route.query.type = 'edit';
        this.type = 'add';
        this.editStart = false;
        this.$services.postLoading({
          type: 'ERP',
          url: 'getBillId',
          params: {
            tableId: 'W_MainOrder',
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          let bean = JSON.parse(res.bean);
          let BillID = bean[0].BillID;
          let FieldValue = bean[0].FieldValue;
          this.formInline.MainOrderID = FieldValue;
          this.MainOrder = FieldValue;
          this.id = BillID;
          this.$route.query.id = BillID;
          this.formInline.BillID = BillID;
          this.dataUpdate = true;
          setTimeout(() => {
            this.dataUpdate = false;
          }, 1000);
          this.formInline.Remark = '';
          this.formInline.OPBeginDate = '';
          this.formInline.OPEndDate = '';
          this.detailInfo.WebType = 0;  //客服部提单复制后编辑权限
          this.$route.query.WebType = 0;
          this.batchNumberList.forEach(v => {
            v.BillID = BillID;
            v.updateFlg = 'add';
            v.RealNumber = '';
            v.ShowIndex = '';
            v.ListID = '';
            v.Number = '';
            v.LeftNumber = '';
            v.AffirmNumber = '';
          });
          this.licenseNumberList.forEach(v => {
            v.BillID = BillID;
            v.State = '';
            v.StateName = '';
            v.ShowIndex = '';
            v.ListID = '';
            v.updateFlg = 'add';
          });
          delete this.detailInfo.IsRed;
          choose ? this.licenseNumberList = [] : '';
        });
      },
      init() {
        if (this.$route.query.type === 'add') this.listConfigAPI();
        this.id = this.$route.query.id;
        this.type = this.$route.query.type;
        this.MainOrder = this.$route.query.MainOrder;
        this.tableOriginData();
        if (this.$route.name === 'addBillLadingLading' || this.$route.name === 'addBillLadingUnload') this.getServiceId();
        if (this.$route.query.type === 'edit' || this.$route.query.type === 'info') {
          this.formInline.BillID = this.$route.query.id;
          this.formInline.MainOrderID = this.$route.query.MainOrder;
          this.detail(this.id);
        }
        if (this.$route.query.type === 'edit') {
          this.editStart = false;
        }
        if (this.$route.query.type === 'add') {
          this.editStart = false;
          this.formInline.BillID = this.id;
          this.formInline.MainOrderID = this.$route.query.MainOrder;
          this.getAvailableDays();
        }
        this.getCheckChecking();
        this.getCheckProcess();
        this.$nextTick(() => {
          this.$refs['topForm'].clearValidate();
        })
      },
      ...mapActions({
        getGoodDicList: 'dictionary/getGoodDicList',
        getGuestIDByConditionsList: 'dictionary/getGuestIDByConditionsList',
        getBargainIDByConditionsList: 'dictionary/getBargainIDByConditionsList',
        getRefGoodsByConditionsList: 'dictionary/getRefGoodsByConditionsList',
        getCarOrderBatch: 'dictionary/adminCarOrderBatchAction',
        getCarOrderList: 'dictionary/adminCarOrderListAction',
        getTGuestIDByConditions: 'dictionary/getTGuestIDByConditions',
        getTankIDByConditions: 'dictionary/getTankIDByConditions',
      }),
      orderTypeC(a, b) {
        let re;
        this.orderType === 'load' ? re = a : '';
        this.orderType === 'unload' ? re = b : '';
        return re;
      },
      listConfigAPI() {
        this.goodDIcDefaultParams = {
          type: 'GUESTBUSINESS',
          url: this.orderTypeC('getOutCarRefGoods', 'getInCarRefGoods'),
          params: {
            goodsId: '',
          },
        };
        this.OrderType = this.orderTypeC(false, true);
        this.getTankIDByConditions(this.orderTypeC(2150,3003));
        this.getGoodDicList();

        // this.getGuestIDByConditionsList(this.OrderType);
        this.getBargainIDByConditionsList(4052);
        this.getRefGoodsByConditionsList(3002);
        // this.getCarOrderBatch(this.OrderType);
        let start = this.orderTypeC(false, true);
        this.getCarOrderBatch(this.orderTypeC(2927,3927));
        this.getCarOrderList(2928);
        // this.getTGuestIDByConditions(false);
        this.annexDetailAPI();
      },
      inputSelectEven(value) {
        this.formInline.BLNO = value.BLNO
      },
      querySearch(queryString, cb) {
        let restaurants = this.getBlnoList;
        let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return restaurant => {
          return (restaurant.BLNO.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      // 车号文件上传
      licenseFileEven(file) {
        this.uploadFileAPI(file);
        return false;
      },
      uploadFileAPI(file) {
        let fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = e => {
          let base64 = e.target.result;
          this.$services.postLoading({
            type: 'GUESTBUSINESS',
            url: 'listExcelCarOrderList',
            params: {
              carListExcel: base64,
              suffix: this.getType(file.name),
            },
          }).then(res => {
            if (res.bean) {
              res.bean.forEach(v => {
                v.uid = this.$utils.getUid();
              });
              this.licenseNumberList = this.licenseNumberList.concat(res.bean);
            }
          });
        }
      },
      getType(file) {
        let filename = file;
        let index1 = filename.lastIndexOf('.');
        let index2 = filename.length;
        let type = filename.substring(index1, index2);
        return type;
      },
      // 按钮状态控制
      buttonStart(type) {
        let start = false;
        if ((this.detailInfo.State2 == 90 || this.detailInfo.State2 == 91)&&this.detailInfo.WebType !== 1) {
          this.editStartCAR = false;
        }
        if ((this.$route.name === 'adminAddBillLadingUnload' || this.$route.name === 'adminAddBillLadingLading') && type !== 1) {
          start = true;
        }
        switch (type) {
          case 1:
            if (!this.editStart || this.detailInfo.State !== 0) {
              start = true;
            }
            break;
          case 2:
            if (!this.editStart) {
              start = false;
            }
            else {
              start = true;
            }
            break;
          case 3:
            if (this.editStart && this.formInline.State === 0 && this.detailInfo.State === 0 && this.detailInfo.WebType !== 1) {
              start = false;
            }
            else {
              start = true;
            }
            break;
          case 4:
            if (this.editStart && this.formInline.State === 0 && this.detailInfo.WebType !== 1) {
              start = false;
            }
            else {
              start = true;
            }
            break;
          case 6:
            if (this.detailInfo.State2 === 2 && this.detailInfo.WebType !== 1) {
              start = false;
            }
            else {
              start = true;
            }
            break;
          case 7:
            if (this.editStart) {
              start = false;
            }
            else {
              start = true;
            }
            break;
          case 10:
            if ((this.detailInfo.State === 0 && this.detailInfo.WebType !== 1) || this.type === 'add') {
              start = true;
            }


            break;
        }
        return start;
      },
      // 时间范围控制
      pickerOptionsEnd(val) {
        let data = {};
        if (val === 'BLEndDate') {
          data = {
            disabledDate: time => (
              time.getTime() < dayjs(this.formInline.BLBeginDate).valueOf() - 24 * 1000 * 60 * 60
              // 可选范围重复24小时
            ),
          };
        }
        return data;
      },
      // 附件上传前的钩子
      beforeAvatarUpload(file) {
        if (this.desc) {
          this.annexUploadAPI(file);
        }
        else {
          this.$message({
            message: '请填写上传附件的说明',
            type: 'warning',
          });
        }
        return false;
      },
      // 单据的附件详情查询
      annexDetailAPI() {
        this.$services.post({
          type: 'ERP',
          url: 'annexDetail',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'W_MainOrder',
            billsId: this.MainOrder,
          },
        }).then(res => {
          this.annexDetailList = res.bean;
        });
      },
      // 单据的附件上传
      annexUploadAPI(file) {
        let listid = 0
        if (this.annexDetailList.length > 0) {
          this.annexDetailList.forEach(itme => {
            if (listid < itme.listid) {
              listid = itme.listid;
            }
          });
        }
        const $loading = Loading.service({
          target: document.querySelector('div.contain'),
          lock: true,
          fullscreen: false,
          text: '附件上传中',
          background: 'transparent',
        });
        let data = {
          updateFlg: 'add',
          accountid: this.userInfor.accountId,
          tableid: 'W_MainOrder',
          billsid: this.MainOrder,
          explain: this.desc,
          annexname: file.file.name,
          operatorid: this.userInfor.userName,
          adddate: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
          annexsize: file.file.size / 1000,
        };
        this.$services.postUrlParams({
          type: 'ERP',
          url: 'annexUpload',
          urlParams: data,
          params: file.file,
        }).then(res => {
          $loading.close();
          if (res.code === '000') {
            this.$message({
              message: '上传成功',
              type: 'success',
            });
          }
          this.desc = '';
          this.uploadFileDesc = false;
          this.annexDetailAPI();
        });
      },
      // 单据附件的下载
      fileDownload(itme) {
        this.$services.download({
          type: 'ERP',
          url: 'annexDownload',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'W_MainOrder',
            billsId: this.MainOrder,
            listId: itme.listid,
            showIndex: itme.showindex,
          },
        }).then(res => {
          this.$utils.downLoad(res, itme.annexname)
        });
      },
      // 单据附件删除
      fileDelete(itme) {
        this.$services.download({
          type: 'ERP',
          url: 'annexRemove',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'W_MainOrder',
            billsId: this.MainOrder,
            listId: itme.listid,
            showIndex: itme.showindex,
          },
        }).then(res => {
          this.annexDetailAPI();
          this.$message({
            message: '删除成功',
            type: 'success',
          });
        });
      },
      // 提单默认有效天数
      getAvailableDays() {
        this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'getAvailableDays',
          params: {
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          this.$set(this.formInline, 'AvailableDays', res.bean);
          this.datePickerEven('BLBeginDate')
        });
      },
      // 作废
      // 审核
      doAudit(type) {
        this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'orderInsertToERP',
          params: {
            accountId: this.userInfor.accountId,
            billId: this.id,
            type,
          },
        }).then(res => {
          if (res.bean) {
            if (type === 1) {
              this.$message({
                message: '作废成功',
                type: 'success',
              });
            }
            else {
              this.$message({
                message: '提交成功',
                type: 'success',
              });
            }
            this.editStart = true;
            this.detail(this.id);
            this.$forceUpdate();
            storage.$set({
              key: 'adminServiceTable',
              parameter: true,
            });
          }
        });
      },
      // 退审
      doCancleAudit() {
        this.$services.post({
          type: 'ERP',
          url: 'doCancleAudit',
          params: {
            pProId: 100022,
            aAccountId: this.userInfor.accountId,
            aTableId: 'W_MainOrder',
            aBillId: this.id,
            aAuditResult: '1',
            aAuditStep: -1,
            pFuncId: 626,
            aOperatorId: this.userInfor.id,
            pAccountId: this.userInfor.accountId,
          }
        }).then(res => {
          if (typeof res.bean === 'string') {
            let bean = JSON.parse(res.bean);
            if (bean.RetMessage) {
              this.$message({
                message: JSON.parse(res.bean).RetMessage,
                type: 'warning',
              });
            }
          }
          this.$router.go(-1);
          // this.detail(this.id);
        });
      },
      // 完成
      doFinish() {
        this.$services.post({
          type: 'ERP',
          url: 'doFinish',
          params: {
            aAuditResult: '1',
            pProId: 100022,
            aAccountId: this.userInfor.accountId,
            aTableId: 'W_MainOrder',
            aBillId: this.id,
            aAuditStep: 0,
            pFuncId: 626,
            aOperatorId: this.userInfor.id,
            pAccountId: this.userInfor.accountId,
          }
        }).then(res => {
          if (typeof res.bean === 'string') {
            let bean = JSON.parse(res.bean);
            if (bean.RetMessage) {
              this.$message({
                message: JSON.parse(res.bean).RetMessage,
                type: 'warning',
              });
            }
          }
          this.$router.go(-1);
        });
      },
      // 作废
      operationDeleteEven() {
        this.$services.postLoading({
          type: 'ERP',
          url: 'doBlankOut',
          params: {
            aAccountId: this.userInfor.accountId,
            aTableId: 'W_MainOrder',
            aBillId: this.id,
            aAuditStep: 0,
            pFuncId: 626,
            aOperatorId: this.userInfor.id,
            pAccountId: this.userInfor.accountId,
          },
        }).then(res => {
          res.code === '000' ? this.$message({
            message: '作废成功！',
            type: 'success',
          }) : '';
          if (typeof res.bean === 'string') {
            let bean = JSON.parse(res.bean);
            if (bean.RetMessage) {
              this.$message({
                message: JSON.parse(res.bean).RetMessage,
                type: 'warning',
              });
            }
          }
          this.$forceUpdate();
          storage.$set({
            key: 'adminServiceTable',
            parameter: true,
          });
          this.$router.go(-1);
          // this.detail(this.id);
        });
      },
      // 获取单据审核信息
      getCheckChecking() {
        this.$services.post({
          type: 'ERP',
          url: 'getCheckChecking',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'MainOrder',
            billId: this.id,
          },
        }).then(res => {
          if (res.bean) {
            this.Step = res.bean.length;
          }
          else {
            this.Step = 0
          }
        });
      },
      // 获取单据审核流程信息，窗体加载时获取
      getCheckProcess() {
        this.$services.post({
          type: 'ERP',
          url: 'getCheckProcess',
          params: {
            accountId: this.userInfor.accountId,
            tableId: 'MainOrder',
          },
        }).then(res => {
        });
      },
      openDialog(key, row = null, orgList) {
        let orgIndex;
        orgList ? orgIndex = orgList.findIndex(x => {
          return x.uid == row.row.uid;
        }) : '';
        if (orgIndex) this.currentTank = orgIndex;
        if (key === 'batch') {
          this.getInCarBatchId();
          return;
        }
        this[key] = !this[key];
      },
      async getInCarBatchId() {
        if (!this.formInline.BLNumber) {
          this.$message({
            message: '请填写提单数',
            type: 'warning',
          });
        }
        const {bean} = await this.$services.post({
          type: 'GUESTBUSINESS',
          url: (this.$route.name === 'billLadingLading' || this.$route.name === 'addBillLadingLading') ? 'getOutCarBatchId' : 'getInCarBatchId',
          params: {
            accountId: this.userInfor.accountId,
            bargainId: this.formInline.BargainID,
            goodsId: this.formInline.GoodsID,
            guestId: this.formInline.GuestID,
            billId: this.formInline.BillID,
            blNumber: this.formInline.BLNumber,
          },
        });
        bean.forEach((itme, key) => {
          itme.updateFlg = 'add';
        });
        this.batchNumberList = bean;
      },
      // 表格初始化数据处理
      tableOriginData() {
        this.fromList.forEach(itme => {
          if (itme.key) this.$set(this.formInline, itme.key, '');
          if (itme.default) this.$set(this.formInline, itme.key, itme.default);
        });
        this.batchNumberCol.forEach(itme => {
          if (itme.field === 'IsInTrade' || itme.field === 'IsOutTrade' || itme.field === 'IsTax') {
            this.$set(this.batchNumberOriginData, itme.field, false);
          }
          else {
            this.$set(this.batchNumberOriginData, itme.field, null);
          }
        });
        this.licenseNumberClo.forEach(itme => {
          if (itme.field === 'IsBL' || itme.field === 'IsDate') {
            this.$set(this.licenseNumberOriginData, itme.field, false);
          }
          this.$set(this.licenseNumberOriginData, itme.field, null);
        });
      },
      // 取装卸车服务编号
      getServiceId() {
        let type;
        if (this.$route.name === 'addBillLadingLading') {
          type = 3;
        }
        else if (this.$route.name === 'addBillLadingUnload') {
          type = 2;
        }
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'getServiceId',
          params: {
            accountId: this.userInfor.accountId,
            type,
            // operatorId: this.userInfor.id,
            operatorId: 'Admin',
          },
        }).then(res => {
          this.getServiceIdList = res.bean;
        });
      },
      // 获取批号表格详情
      batchdetail(id) {
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'listCarOrderBatch',
          params: {
            accountId: this.userInfor.accountId,
            billId: String(id),
            webType: Number(this.$route.query.WebType),
          },
        }).then(({bean}) => {
          this.batchNumberList = bean;
          this.batchNumberList.forEach((itme, key) => {
            itme.id = key + 1;
            itme.uid = this.$utils.getUid();
          });
        });
      },
      // 获取车号表格详情
      LicenseNumberdetail(id) {
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'listCarOrderList',
          params: {
            accountId: this.userInfor.accountId,
            billId: String(id),
            webType: Number(this.$route.query.WebType),
          },
        }).then(({bean}) => {
          this.licenseNumberList = bean;
          this.licenseNumberList.forEach((itme, key) => {
            itme.id = key + 1;
            itme.uid = this.$utils.getUid();
          });
        });
      },
      // 获取台账详情
      detail(id, t) {
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'detail',
          params: {
            accountId: this.userInfor.accountId,
            billId: String(id),
            webType: Number(this.$route.query.WebType),
          },
        }).then(({bean}) => {
          this.$set(this.formInline, 'BillID', bean.BillID);
          this.$set(this.formInline, 'GuestID', bean.GuestID);
          this.$set(this.formInline, 'Name', bean.GuestName);
          this.$set(this.formInline, 'BargainID', bean.BargainID);
          this.$set(this.formInline, 'CEGoodsName', bean.GoodsName);
          this.$set(this.formInline, 'GoodsID', bean.GoodsID);
          this.$set(this.formInline, 'BLNO', bean.BLNO);
          this.$set(this.formInline, 'BLNumber', bean.BLNumber);
          this.$set(this.formInline, 'BLBeginDate', bean.BLBeginDate);
          this.$set(this.formInline, 'BLEndDate', bean.BLEndDate);
          this.$set(this.formInline, 'PreDate', bean.PreDate);
          this.$set(this.formInline, 'Location', bean.Location);
          this.$set(this.formInline, 'OperatorName', bean.OperatorName);
          this.$set(this.formInline, 'IsNon', bean.IsNon !== 0);
          this.$set(this.formInline, 'ExtractSample', bean.ExtractSample !== null && bean.ExtractSample !== 0);
          this.$set(this.formInline, 'NeedAssay', bean.NeedAssay);
          this.$set(this.formInline, 'CreateDate', bean.CreateDate);
          this.$set(this.formInline, 'OperatorID', bean.OperatorID);
          this.$set(this.formInline, 'Remark', bean.Remark);
          this.$set(this.formInline, 'SpecialRequest', bean.SpecialRequest);
          this.$set(this.formInline, 'AvailableDays', (dayjs(bean.BLEndDate).diff(dayjs(bean.BLBeginDate), 'day')) + 1);
          this.$set(this.formInline, 'GuestName', bean.GuestName);
          this.$set(this.formInline, 'State', bean.State);
          this.$set(this.formInline, 'TGuestName', bean.TGuestName);
          this.$set(this.formInline, 'TGuestID', bean.TGuestID);
          this.batchNumberList = bean.carOrderBatchList;
          this.batchNumberList.forEach((itme, key) => {
            itme.id = key + 1;
            itme.uid = this.$utils.getUid();
          });
          this.licenseNumberList = bean.carOrderListList;
          this.licenseNumberList.forEach((itme, key) => {
            itme.id = key + 1;
            itme.uid = this.$utils.getUid();
          });
          if (this.type === 'add' && t) this.dataUpdate = true;
          this.detailInfo = bean;
          this.OrderType = bean.OrderType === 2 ? true : false;
          this.getTankIDByConditions(this.orderTypeC(2150,3003));
          this.listConfigAPI();
          this.$nextTick(() => {
            this.$refs.batchTable.initTable();
            this.$nextTick(() => {
              this.$refs.licenseTable.initTable();
              this.$forceUpdate();
            })
          })
        });
      },
      // 添加table数据列
      addNewBatchNumberData(callback) {
        this.batchNumberList.push(JSON.parse(JSON.stringify(
          Object.assign(this.batchNumberOriginData, {
            uid: this.$utils.getUid(),
            id: this.batchNumberList.length + 1,
            BillID: Number(this.$route.query.id),
            AccountID: this.userInfor.accountId,
            ListID: this.licenseNumberList.length + 1,
            ShowIndex: this.batchNumberOriginData.length,
            IsInTrade: true,
            State: 0,
            updateFlg: 'add',
            Remark: ''
          }),
        )));
        this.$nextTick(() => {
          if (typeof callback === 'function') callback();
        });
      },
      saveLicenseNumberData(){
        let start = false;
        this.licenseNumberList.forEach((itme, key) => {
          if(start) return;
          if (itme.updateFlg !== 'delete') {
            let keyList = Object.keys(itme);
            keyList.forEach(keyListConter => {
              if(start) return;
              this.licenseNumberClo.forEach(licenseNumberCloConter => {
                if (!licenseNumberCloConter.isNull && itme[licenseNumberCloConter.field] === undefined) {
                  this.$message({
                    message: `${licenseNumberCloConter.fieldAlias}数据未填写`,
                    type: 'warning',
                  });
                  start = true;
                  return;
                }
                if (['IsSingle', 'Number'].findIndex(v => v === licenseNumberCloConter.field) > -1 && itme[licenseNumberCloConter.field] < 0) {
                  this.$message({
                    message: `${licenseNumberCloConter.fieldAlias}不能小于0`,
                    type: 'warning',
                  });
                  start = true;
                  return;
                }
              })
            });
          }
          // delete itme.uid;
          // delete itme.id;
          itme.IsDate === null ? itme.IsDate = 0 : '';
          itme.IsLimit === null ? itme.IsLimit = 0 : '';
          if (!itme.updateFlg && !itme.UpdateFlg) itme.updateFlg = 'update';
        });
        if (start) return false;
          this.$services.postLoading({
            type: 'GUESTBUSINESS',
            url: 'saveCarOrderListList',
            params: {
              data: JSON.stringify(this.licenseNumberList),
            },
          }).then(res => {
            if (res.bean) {
              this.$message({
                message: '保存成功',
                type: 'success',
              });
              this.$forceUpdate();
            }
          });
      },
      addNewLicenseNumberData(callback) {
        this.licenseNumberList.push(JSON.parse(JSON.stringify(
          Object.assign(this.licenseNumberOriginData, {
            uid: this.$utils.getUid(),
            id: this.licenseNumberList.length + 1,
            BillID: Number(this.$route.query.id),
            AccountID: this.userInfor.accountId,
            ListID: this.licenseNumberList.length + 1,
            ShowIndex: 1,
            IsSingle: 1,
            State: 0,
            updateFlg: 'add',
          }),
        )));
        this.$nextTick(() => {
          if (typeof callback === 'function') callback();
        });
      },
      // 批号列表
      // getBatchNoAPI() {
      //   let params = {
      //     accountId: this.userInfor.accountId,
      //     bargainId: this.formInline.bargainId,
      //     goodsId: this.formInline.goodsId,
      //     guestId: this.formInline.guestID,
      //     billId: '',
      //     blNumber: ''
      //   };
      //   this.$services.postLoading({
      //     type: '',
      //     url: '',
      //     params
      //   }).then(res => {
      //
      //   });
      // },
      // 合同号弹出选择
      getBargainEven() {
        let params = {
          accountId: this.userInfor.accountId,
          guestId: this.formInline.GuestID ? this.formInline.GuestID : '',
          goodsId: this.formInline.GoodsID ? this.formInline.GoodsID : '',
          serviceId: (this.$route.name === 'billLadingLading' || this.$route.name === 'addBillLadingLading') ? '08' : '09',
        };
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'mainOrderGetBargainId',
          params,
        }).then(res => {
          this.bargainList = res.bean;
        });
      },
      // 客户弹出选择
      getRefVGuestAPI() {
        let params = {
          accountId: this.userInfor.accountId,
          guestId: this.formInline.GuestID ? this.formInline.GuestID : '',
          goodsId: this.formInline.GoodsID ? this.formInline.GoodsID : '',
          serviceId: (this.$route.name === 'billLadingLading' || this.$route.name === 'addBillLadingLading') ? '08' : '09',
        };
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'getRefVGuest',
          params,
        }).then(res => {
          this.guestIDList = res.bean;
        });
      },
      // 提货人编号
      getTGuestNum() {
        let params = {
          accountId: this.userInfor.accountId,
        };
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'getTGuest',
          params,
        }).then(res => {
          this.getTGuestNumList = res.bean;
        });
      },
      selectRow(row) {
        this.$refs.pointSet.setCurrentRow(row);
      },
      clickFn(row) {
        this.$refs.pointSet.clearSelection();
        this.$refs.pointSet.toggleRowSelection(row);
      },
      // 用户选择表格事件
      batchNumberSelectionChange(selection) {
        let idAll = [];
        selection.forEach(itme => {
          idAll.push(itme.uid);
        });
        this.batchNumberUserSelectId = idAll;
      },
      licenseNumberSelectionChange(selection) {
        let idAll = [];
        selection.forEach(itme => {
          idAll.push(itme.uid);
        });
        this.licenseNumberUserSelectId = idAll;
      },
      // 删除
      batchNumberDelete() {
        if (this.batchNumberUserSelectId.length < 1) {
          this.$message({
            type: 'warning',
            message: '暂未选择要删除的数据',
          });
          return false;
        }
        this.$confirm('是否删除选中的' + this.batchNumberUserSelectId.length + '条数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.batchNumberUserSelectId.forEach(itme => {
            this.batchNumberList.forEach((batchInfo, batchKey) => {
              if (itme === batchInfo.uid) {
                let data = batchInfo;
                data.updateFlg = 'delete';
                this.batchNumberList.splice(batchKey, data);
              }
            });
          });
        });
      },
      licenseNumberDelete() {
        if (this.licenseNumberUserSelectId.length < 1) {
          this.$message({
            type: 'warning',
            message: '暂未选择要删除的数据',
          });
          return false;
        }
        this.$confirm('是否删除选中的' + this.licenseNumberUserSelectId.length + '条数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.licenseNumberUserSelectId.forEach(itme => {
            this.licenseNumberList.forEach((batchInfo, batchKey) => {
              if (itme === batchInfo.uid) {
                let data = batchInfo;
                data.updateFlg = 'delete';
                this.licenseNumberList.splice(batchKey, data);
              }
            });
          });
        });
      },
      // 获取附加合同
      getAttachBargainAPI() {
        this.$services.post({
          type: 'GUESTBUSINESS',
          url: 'getAttachBargain',
          params: {
            // billId:12238,
            // mainOrderId: 'DD18090224',
            accountId: this.userInfor.accountId,
            bargianId: 'VB-S14-180731-022',
            goodsId: 'VTN00008',
            guestId: 'V0054'
            // accountId: this.userInfor.accountId,
            // goodsId: this.formInline.GoodsID,
            // guestId: this.formInline.GuestID,
            // bargainId: this.formInline.BargainID
          }
        }).then(res => {
        })
      },
      //撤回接口
      revoke() {
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'orderRevoke',
          params: {
            billId: this.detailInfo.BillID,
            accountId: this.userInfor.accountId,
          },
        }).then(res => {
          if (typeof res.bean === 'string') {
            let bean = JSON.parse(res.bean);
            if (bean.RetMessage) {
              this.$message({
                message: JSON.parse(res.bean).RetMessage,
                type: 'warning',
              });
            }
          }
          else if (res.bean[0].RetCode == 100) {
            this.$message({
              message: '撤回成功！',
              type: 'success',
            });
            this.detail(this.id);
            this.$forceUpdate();
            storage.$set({
              key: 'adminServiceTable',
              parameter: true,
            });
          }
        });
      },
      doOperate(t) {
        switch (t) {
          case '0':
            this.checkForm();
            break;
          case '1':
            this.doAudit(this.currFpar);
            break;
          case '2':
            this.revoke();
            break;
          case '3':
            this.operationDeleteEven();
            break;
          default:
            break;

        }
      },
      riskCheck(f, p) {
        this.$services.postLoading({
          type: 'GUESTBUSINESS',
          url: 'getRiskCtrlLevel',
          params: {accountId: this.userInfor.accountId},
        }).then(res => {
          if (res.bean) {
            this.currF = f;
            this.currFpar = p;
            res.bean.riskCtrlLevel == 2 ? this.sendCode() : this.doOperate(f);
          }
        });
      },
      sendCode() {
        if (this.userInfor.phone) {
          this.$services.postLoading({
            type: 'WECHAT',
            url: 'sendSMSCode',
            params: {phoneNumber: this.userInfor.phone},
          }).then(res => {
            if (res.code === '000') {
              this.Codephone = this.userInfor.phone.replace(/^(\d{3})\d{4}(\d+)/, '$1****$2');
              this.msgCodeShow = true;
            }
          });
        }
        else {
          this.$message({
            message: '未维护手机号，不允许下单。请与客服人员联系后重试！',
            type: 'error',
          });
        }
      },
      checkMsgCode() {
        this.$services.postLoading({
          type: 'BUSINESS',
          url: 'checkRefPhone',
          params: {phoneNumber: this.userInfor.phone, SMSCode: this.msgCode},
        }).then(res => {
          if (res.code === '000') {
            this.msgCodeShow = !this.msgCodeShow;
            this.$message({
              message: '校验成功，执行保存',
              type: 'success',
            });
            // this.checkForm();
            this.doOperate(this.currF);
          }
          else {
            this.$message({
              message: '校验失败，请重新输入',
              type: 'error',
            });
          }
        });
      },
      checkForm() {
        this.$refs['topForm'].validate((valid) => {
          if (valid) {
            this.complete();
          } else {
            this.$message({
              message: '请将选项填写完整',
              type: 'warning',
            });
            return false;
          }
        });
      },
      toggleSelection() {
        this.$refs.batchTable ? this.$refs.batchTable.$children[0].clearSelection() : '';
        this.$refs.licenseTable ? this.$refs.licenseTable.$children[0].clearSelection() : '';
      },
      // 保存接口
      complete() {
        let batchNumber = 0;
        let start = false;
        this.toggleSelection();
        this.batchNumberList.forEach((itme, key) => {
          if(start) return;
          if (itme.CanNumber && String(itme.CanNumber)) itme.CanNumber = Number(itme.CanNumber);
          if (itme.Number && String(itme.Number)) itme.Number = Number(itme.Number);
          if (itme.updateFlg !== 'delete') {
            batchNumber = batchNumber + Number(itme.Number);

            for (let j = 0; j < this.batchNumberCol.length; j++) {
              if(start) return;
              if (!this.batchNumberCol[j].isNull && !this.batchNumberList[key][this.batchNumberCol[j].field]) {
                if (this.batchNumberCol[j].field === 'IsInTrade' ||
                  this.batchNumberCol[j].field === 'IsOutTrade' ||
                  this.batchNumberCol[j].field === 'IsTax') {
                  if (this.batchNumberList[key].IsInTrade + this.batchNumberList[key].IsOutTrade + this.batchNumberList[key].IsTax < 1) {
                    this.$message({
                      message: `${this.batchNumberCol[j].fieldAlias}数据未填写`,
                      type: 'warning',
                    });
                    start = true;
                    return false;
                  }
                } else {
                  this.$message({
                    message: `${this.batchNumberCol[j].fieldAlias}数据未填写`,
                    type: 'warning',
                  });
                  start = true;
                  return false;
                }
              }
            }

          }
          // delete itme.uid;
          // delete itme.id;
          itme.IsInTrade === null ? itme.IsInTrade = 0 : '';
          itme.updateFlg === 'add' ? delete itme.ListID : '';
          if (!itme.updateFlg) itme.updateFlg = 'update';
        });
        if (start) return false;
        if (batchNumber !== Number(this.formInline.BLNumber) && !start) {
          this.$message({
            message: '罐号' + this.orderTypeC('发货量', '卸货量') + '不等于提单数！',
            type: 'warning',
          });
          return false;
        }
        this.licenseNumberList.forEach((itme, key) => {
          if(start) return;
          if (itme.updateFlg !== 'delete') {
            let keyList = Object.keys(itme);
            keyList.forEach(keyListConter => {
              this.licenseNumberClo.forEach(licenseNumberCloConter => {
                if(start) return;
                if (!licenseNumberCloConter.isNull && itme[licenseNumberCloConter.field] === undefined) {
                  this.$message({
                    message: `${licenseNumberCloConter.fieldAlias}数据未填写`,
                    type: 'warning',
                  });
                  start = true;
                  return;
                }
                if (['IsSingle', 'Number'].findIndex(v => v === licenseNumberCloConter.field) > -1 && itme[licenseNumberCloConter.field] < 0) {
                  this.$message({
                    message: `${licenseNumberCloConter.fieldAlias}不能小于0`,
                    type: 'warning',
                  });
                  start = true;
                  return;
                }
              })
            });
          }
          // delete itme.uid;
          // delete itme.id;
          itme.IsDate === null ? itme.IsDate = 0 : '';
          itme.IsLimit === null ? itme.IsLimit = 0 : '';
          if (!itme.updateFlg && !itme.UpdateFlg) itme.updateFlg = 'update';
        });
        if (start) return false;
        this.detailInfo.TGuestID = this.userInfor.depCode;
        this.detailInfo.TGuestName = this.userInfor.departName;
        this.detailInfo.carOrderBatchList = this.batchNumberList;
        this.detailInfo.carOrderListList = this.licenseNumberList;
        this.detailInfo = Object.assign(this.detailInfo, this.formInline);
        this.detailInfo.GoodsName = this.formInline.CEGoodsName;
        this.detailInfo.updateFlg = (this.type === 'edit' || this.type === 'info') ? 'update' : 'add';
        this.detailInfo.IsNon = this.detailInfo.IsNon ? 1 : 0;
        this.detailInfo.ExtractSample = this.detailInfo.ExtractSample ? 1 : 0;
        this.detailInfo.NeedAssay = this.detailInfo.NeedAssay ? 1 : 0;
        this.detailInfo.WebType = Number(this.$route.query.WebType);
        this.detailInfo.operatorId = this.userInfor.userName;
        if (this.type === 'add') {
          this.detailInfo.AccountID = this.userInfor.accountId;
          this.detailInfo.W_MainOrderID = this.MainOrder;
          this.detailInfo.ServiceID = this.$route.name === 'adminAddBillLadingLading' || this.$route.name === 'adminBillLadingLading' ? '09' : '08';
          this.detailInfo.OrderType = this.$route.name === 'adminAddBillLadingLading' || this.$route.name === 'adminBillLadingLading' ? 3 : 2;
          this.detailInfo.State = 0;
          this.detailInfo.IsNon = Number(this.formInline.IsNon);
          this.detailInfo.ExtractSample = Number(this.formInline.ExtractSample);
          this.detailInfo.Number = Number(this.formInline.BLNumber);
          this.detailInfo.GoodsID = this.formInline.GoodsID;
          this.detailInfo.CreateDate = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
        }
        if (this.dataCheck()) return false;
        this.saveTest().then(r => {
          this.$services.postLoading({
            type: 'GUESTBUSINESS',
            url: 'save',
            params: {
              data: JSON.stringify(this.detailInfo),
            },
          }).then(res => {
            if (res.bean) {
              this.$message({
                message: '保存成功',
                type: 'success',
              });
              this.editStart = true;
              if (this.type === 'add') {
                this.visitedViews.forEach(v => {
                  if (v.path === this.$route.path) {
                    v.title = v.title.replace(/新增/, '') + '详情';
                  }
                });
              }
              this.type = 'info';
              this.detail(this.id, true);
              storage.$set({
                key: 'adminServiceTable',
                parameter: true,
              });
              this.$forceUpdate();
            }
          });
        })

      },
      saveTest() {
        return new Promise((res, rej) => {
          this.$services.postLoading({
            type: 'GUESTBUSINESS',
            url: 'orderValidateBeforeSave',
            params: {
              accountId: this.userInfor.accountId,
              orderType: this.detailInfo.OrderType,
              bargainId: this.detailInfo.BargainID,
            },
          }).then(re => {
            if (re.code === '000') {
              res();
            }
          })
        });

      },
      dataCheck() {
        let start = false;
        let arr = [
          {key: 'GoodsID', tips: '请选择产品',}
        ];
        arr.forEach(itme => {
          if (!this.detailInfo[itme.key]) {
            start = true;
            this.$message({
              message: itme.tips,
              type: 'warning',
            });
          }
        });
        return start;
      },
      batchInitCol() {
        this.carOrderBatch.length > 0 && (this.batchNumberCol = this.carOrderBatch.map(itme => {
            let info = itme;
            info.field = itme.fieldName;
            info.title = itme.fieldAlias;
            info.width = itme.displayWidth;
            info.IsNull = itme.IsNull;
            return info;
          })
        );
      },
      licenseInitCol() {
        this.carOrderList.length > 0
        && (this.licenseNumberClo = this.carOrderList.map(itme => {
            let info = itme;
            info.field = itme.fieldName;
            info.title = itme.fieldAlias;
            info.width = itme.displayWidth;
            info.IsNull = itme.IsNull;
            return info;
          })
        );
      },
      inputChangeEven(key) {
        if (key === 'AvailableDays') {
          let newDay = dayjs(this.formInline.BLBeginDate).unix();
          let s = (Number(this.formInline.AvailableDays) - 1) * 86400 + newDay;
          this.formInline.BLEndDate = `${this.$utils.getTimeByDay(dayjs.unix(s).format('YYYY-MM-DD HH:mm:ss'))} ${ this.formInline.BLEndDate.split(' ')[1]}`;
        }
        switch (key) {
          case 'CEGoodsName':
            this.formInline.GoodsID = '';
            break;
          case 'Name':
            this.formInline.GuestID = '';
            break;
          case 'TGuestName':
            this.formInline.TGuestID = '';
            break;
          default:
            break;
        }
      },
      datePickerEven(key) {
        if (key === 'BLBeginDate') {
          let a = this.formInline.BLEndDate.split(' ')[1];
          this.formInline.BLEndDate = `${this.$utils.getTimeByDay(dayjs.unix(dayjs(this.formInline.BLBeginDate).unix() + (86400 * (this.formInline.AvailableDays - 1))).format('YYYY-MM-DD HH:mm:ss'))}`;
          this.formInline.BLEndDate += ' ' + a;
          let futureDay = dayjs(this.formInline.BLEndDate);
          let newDay = dayjs(this.formInline.BLBeginDate);
          this.formInline.AvailableDays = futureDay.diff(newDay, 'day') + 1;
        }
        else if (key === 'BLEndDate') {
          if (dayjs(this.formInline.BLEndDate) < dayjs(this.formInline.BLBeginDate)) {
            this.$message({
              message: '结束日期不可以小于开始日期',
              type: 'error',
            });
            this.formInline.BLEndDate = `${this.$utils.getTimeByDay(dayjs.unix(dayjs(this.formInline.BLBeginDate).unix() + (86400 * (this.formInline.AvailableDays - 1))).format('YYYY-MM-DD HH:mm:ss'))} 23:59:59`;
          }
          let futureDay = dayjs(this.formInline.BLEndDate);
          let newDay = dayjs(this.formInline.BLBeginDate);
          this.formInline.AvailableDays = futureDay.diff(newDay, 'day') + 1;
        }
      },
      clearBatchNumberList() {
        this.batchNumberList.forEach((batchInfo, batchKey) => {
          batchInfo.updateFlg = 'delete';
          this.batchNumberList.splice(batchKey, batchInfo);
        });
      }
    }
    ,
    watch: {
      editStart(v) {
        if (this.detailInfo.State2 == 90 || this.detailInfo.State2 == 91) {
          this.editStartCAR = false;
        }
        else {
          this.editStartCAR = v;
        }
      },
      'formInline.BLNumber'(val) {
        if (this.batchFilterData.length === 1) {
          let Index = this.batchNumberList.findIndex(v => v.updateFlg !== 'delete');
          Index > -1 ? this.$set(this.batchNumberList[Index], 'Number', val) : '';
        }
      }
      ,
      BargainListParams: {
        deep: true,
        handler:

          function (val) {
            !this.dataUpdate ? this._getDataList(this.BargainListParams, this.BargainIDDefaultValue, 'BargainList') : '';
          }

        ,
      }
      ,
      locationListParams: {
        deep: true,
        handler:

          function (val) {
            this.formInline.Location = '';
            !this.dataUpdate ? this._getDataList(this.locationListParams, this.locationDefaultValue, 'locationList') : '';
          }

        ,
      }
      ,
      refGoodsDefaultParams: {
        deep: true,
        handler:

          function (val) {
            !this.dataUpdate ? this._getDataList(this.refGoodsDefaultParams, this.goodsDefaultValue, 'refGoodsList') : '';
          }

        ,
      }
      ,
      TankIDDefaultParams: {
        deep: true,
        handler:

          function (val, o) {
            !this.dataUpdate && val ? this._getDataList(this.TankIDDefaultParams, this.TankIDDefaultValue, 'TankIDList') : '';
          }

        ,
      }
      ,
      carOrderBatch() {
        this.batchInitCol();
      }
      ,
      carOrderList() {
        this.licenseInitCol();
      }
      ,
      licenseNumberClo() {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
      ,
      batchNumberCol() {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
      ,
      activeName(val) {
        if (val === '车号信息') {
          this.$nextTick(() => {
            this.$refs.licenseTable.initTable();
          })
        }
        else if (val === '罐号信息') {
          this.$nextTick(() => {
            this.$refs.batchTable.initTable();
          })
        }
      }
      ,
      /* 'formInline.GuestID'() {
         this.clearBatchNumberList()
       },*/
      'formInline.GoodsID'(newV, oldV) {
        oldV !== '' ? this.clearBatchNumberList() : '';
      }
      ,
      'formInline.BargainID'(newV, oldV) {
        oldV !== '' ? this.clearBatchNumberList() : '';
      }
      ,
      'formInline.TGuestID'(newV, oldV) {
        oldV !== '' ? this.clearBatchNumberList() : '';
      }
      ,
      '$route.name':

        function () {
          /* this.fromList.forEach(itme => {
             this.$set(this.formInline, itme.key, '');
           });*/
        }

      ,
      'batchNumberList':

        function (newVal, oldVal) {
          let start = false
          newVal.forEach(itme => {
            if (itme.updateFlg !== 'delete') start = true;
          });
          if (start && newVal[0]) {
            this.batchNumberListStyle = {
              'minHeight': '100px'
            };
            this.batchNumberListHeight = {
              minHeight: '100px',
              marginBottom: '10px'
            };
          }
          else {
            this.batchNumberListStyle = {
              'minHeight': '100px'
            };
            this.batchNumberListHeight = {
              minHeight: '100px',
              marginBottom: '0px'
            };
          }
          this.$forceUpdate();
        }

      ,
      'licenseNumberList':

        function (newVal, oldVal) {
          let start = false
          newVal.forEach(itme => {
            if (itme.updateFlg !== 'delete') start = true;
          });
          if (start && newVal[0]) {
            this.licenseNumberListStyle = {
              minHeight: '240px'
            };
            this.licenseNumberListHight = {
              minHeight: '100px',
            };
            if (this.batchNumberList[0]) {
              this.licenseNumberListStyle = {
                minHeight: '200px'
              };
              this.licenseNumberListHight = {
                minHeight: '100px',
              };
            }
          }
          else {
            this.licenseNumberListStyle = {
              minHeight: '100px'
            };
            this.licenseNumberListHight = {
              minHeight: '100px',
            };
          }
          this.$forceUpdate();
        }
    }
    ,
  }
  ;
</script>
<style lang="scss">
  .edit {
    .halfW {
      width: 12.5% !important;
      .el-input__inner {
        padding: 0 3px !important;
      }
    }
    .redTxt {
      textarea {
        color: #ff6464 !important;
      }
    }
    .batchTable {
      .el-table__body-wrapper {
        max-height: 150px !important;
      }
    }
    .el-table__body-wrapper {
      max-height: 300px;
      min-height: 80px;
    }
    .el-upload__input {
      display: none;
    }
    .standing_conter {
      overflow-y: scroll;
    }
    .el-input-group__append .el-button {
      margin: 0;
    }
    .edit_table {
      width: 100%;
      min-height: 400px;
    }
    .el-autocomplete {
      width: 100%;
      input {
        width: 100%;
      }
    }
    .standing-bar {
      .el-button--small {
        margin: 5px;
      }
    }
    .spanEdit {
      height: 34px;
      background: #F5F7FA;
      margin: 0 -3px -7px -3px;
      padding: 4px 10px;
    }
    .required {
      label {
        &:before {
          display: inline-block;
          content: '*';
          color: red;
        }
      }
    }
  }
</style>
